import type { ChatNode, ChatOption } from '../types/chat';

/** The option that opens the quest invitation in a conversation */
export const questOption = (prefix: string): ChatOption => ({
  label: 'Why are you glitching?',
  next: `${prefix}-ask`,
  reaction: 'sad',
  quest: true,
  // From this moment his face visibly glitches (subtly, now and then) until the quest is done
  action: { type: 'glitch' },
});

/**
 * Pixel asks for help with his shattered memory core. Taking part needs two confirmations
 * ("I'll help" → "Start the quest"); "Maybe later" goes back to `back` in the same conversation.
 */
export function questEntryNodes(prefix: string, back: string): ChatNode[] {
  const later: ChatOption = { label: 'Maybe later', next: `${prefix}-later`, reaction: 'sad', quest: true };
  return [
    {
      id: `${prefix}-ask`,
      lines: [
        { text: 'Glitch— me? I’m not gl— I’m FINE.', emotion: 'surprised' },
        { text: '…Okay. When I crash-landed, my memory core shattered.', emotion: 'sad' },
        { text: 'Five shards. Hidden somewhere on this website.', emotion: 'sad' },
        { text: 'Without them I can’t remember the way home.', emotion: 'sad' },
        { text: 'I need a human. A curious one. Is that you?', emotion: 'curious' },
      ],
      options: [
        { label: 'Count me in', next: `${prefix}-confirm`, reaction: 'happy', quest: true },
        { label: 'Memory core?', next: `${prefix}-what`, reaction: 'curious', quest: true },
        later,
      ],
    },
    {
      id: `${prefix}-what`,
      lines: [
        { text: 'It’s where I keep everything. Names. Moons. Snacks.', emotion: 'curious' },
        { text: 'Right now it’s 96% empty and making a rattling noise.', emotion: 'sad' },
        { text: 'The shards are glowing. You’ll know them when you see them.', emotion: 'curious' },
      ],
      options: [{ label: 'Count me in', next: `${prefix}-confirm`, reaction: 'happy', quest: true }, later],
    },
    {
      id: `${prefix}-confirm`,
      lines: [
        { text: 'REALLY?! Okay. Operation Memory Core.', emotion: 'surprised' },
        { text: 'I’ll stick right by you. Ready?', emotion: 'happy' },
      ],
      options: [
        { label: 'Begin the hunt', next: `${prefix}-go`, reaction: 'happy', action: { type: 'quest' }, quest: true },
        later,
      ],
    },
    {
      id: `${prefix}-go`,
      lines: [{ text: 'Operation Memory Core: GO. Follow me!', emotion: 'happy' }],
      options: [],
    },
    {
      id: `${prefix}-later`,
      lines: [
        { text: 'Okay. I’ll just … rattle quietly over here.', emotion: 'sad' },
        { text: 'Ask me again whenever you’re ready.', emotion: 'curious' },
      ],
      options: [{ label: 'Back to chatting', next: back, reaction: 'happy' }],
    },
  ];
}
